import React from 'react';
import AsyncSelect from 'react-select/async';
import Service from '../../Service/Service';
import { filterSanctionedAirports } from '../../constants/sanctionedCountries';

/** Red loading spinner, no blue background */
const LoadingIndicator = (props) => (
  <div
    {...props.innerProps}
    style={{
      display: 'flex',
      alignItems: 'center',
      padding: '8px 12px',
      backgroundColor: 'transparent',
      color: '#5c4033',
    }}
  >
    <span
      style={{
        width: 18,
        height: 18,
        border: '2px solid #fecaca',
        borderTopColor: '#5c4033',
        borderRadius: '50%',
        animation: 'react-select-loading-spin 0.8s linear infinite',
      }}
    />
    <style>{`
      @keyframes react-select-loading-spin {
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

const loadOptions = (inputValue, callback) => {
  if (!inputValue || inputValue.length < 3) {
    callback([]);
    return;
  }

  Service.postAirportSearch({ keyword: inputValue })
    .then(response => {
      let data = response.data.data || [];
      data = filterSanctionedAirports(data);
      let options = data.map(s => ({
        label: s.name,
        value: s.iata_code ? s.iata_code : s.address.iata_city_code
      }));
      // Put Lahore, Karachi, Islamabad at end of list
      const pkPriority = ['LHE', 'KHI', 'ISB'];
      const sorted = [...options].sort((a, b) => {
        const ia = pkPriority.indexOf(a.value);
        const ib = pkPriority.indexOf(b.value);
        if (ia === -1 && ib === -1) return 0;
        if (ia === -1) return -1;
        if (ib === -1) return 1;
        return ia - ib;
      });
      callback(sorted);
    })
    .catch(err => {
      callback([]);
    });
};

export default ({ onChange, placeholder, value }) => {
  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadOptions}
      defaultOptions={false}
      onChange={(selected) => {
        onChange(selected);
      }}
      value={value}
      placeholder={placeholder || "Select..."}
      isSearchable={true}
      isClearable={false}
      menuPlacement="auto"
      loadingMessage={() => 'Searching...'}
      noOptionsMessage={({ inputValue }) => {
        if (!inputValue || inputValue.length < 3) {
          return "Type at least 3 characters to search";
        }
        return "No airports found";
      }}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuShouldScrollIntoView={false}
      components={{
        LoadingIndicator,
      }}
      classNames={{
        control: () => 'min-h-[50px] w-full bg-transparent border-none',
        menu: () => 'bg-white shadow-xl rounded-lg border border-gray-200',
        menuList: () => 'py-2',
        option: (state) => state.isSelected ? 'bg-secondary text-white' : state.isFocused ? 'bg-navy-50' : 'bg-white',
      }}
      styles={{
        control: (base, state) => ({
          ...base,
          backgroundColor: 'transparent',
          border: 'none',
          boxShadow: 'none',
          minHeight: '50px',
          cursor: 'text',
          pointerEvents: 'auto',
        }),
        menu: (base) => ({
          ...base,
          backgroundColor: '#ffffff',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          border: '1px solid #e5e7eb',
          borderRadius: '0.5rem',
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 999999,
        }),
        menuList: (base) => ({
          ...base,
          padding: '0.5rem',
          backgroundColor: '#ffffff',
          maxHeight: '300px',
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected
            ? '#2563eb'
            : state.isFocused
            ? '#eff6ff'
            : '#ffffff',
          color: state.isSelected ? '#ffffff' : '#374151',
          cursor: 'pointer',
          padding: '0.625rem 0.875rem',
          borderRadius: '0.375rem',
          fontSize: '0.875rem',
          '&:active': {
            backgroundColor: '#2563eb',
          },
        }),
        input: (base) => ({
          ...base,
          color: '#374151',
          fontSize: '0.875rem',
        }),
        placeholder: (base) => ({
          ...base,
          color: '#9CA3AF',
          fontSize: '0.875rem',
        }),
        singleValue: (base) => ({
          ...base,
          color: '#374151',
          fontSize: '0.875rem',
        }),
        indicatorSeparator: () => ({
          display: 'none',
        }),
        dropdownIndicator: (base) => ({
          ...base,
          color: '#9CA3AF',
          cursor: 'pointer',
          '&:hover': {
            color: '#6B7280',
          },
        }),
        loadingIndicator: (base) => ({
          ...base,
          backgroundColor: 'transparent',
          color: '#5c4033',
        }),
        loadingMessage: (base) => ({
          ...base,
          backgroundColor: 'transparent',
          color: '#374151',
        }),
      }}
    />
  );
};
